export const DELIVERY_TYPE_ETICKET = 'eticket';
export const DELIVERY_TYPE_PHYSICAL = 'physical';
export const DELIVERY_TYPE_OTHER = 'other';

export const DELIVERY_STATUS_PENDING = 0;
export const DELIVERY_STATUS_PREPARING = 1;
export const DELIVERY_STATUS_DOWNLOAD_READY = 2;
export const DELIVERY_STATUS_TRACKING_READY = 3;

export const DELIVERY_STATUS_DESCRIPTION = {
  [DELIVERY_STATUS_PENDING]: 'Order placed',
  [DELIVERY_STATUS_PREPARING]: 'Being prepared',
  [DELIVERY_STATUS_DOWNLOAD_READY]: 'Ready to download',
  [DELIVERY_STATUS_TRACKING_READY]: "On it's way",
};
